<script setup lang="ts">
import { faBookmark } from '@fortawesome/pro-light-svg-icons'
import { SHOW_AT, type FilterBreakpoint } from '~/utils/filter/chips'

const { breakpoint } = defineProps<{
  breakpoint: FilterBreakpoint
}>()

const pressed = defineModel<boolean>({ required: true })

const { loggedIn } = useUserSession()
</script>

<template>
  <Chip
    v-if="loggedIn"
    size="large"
    variant="neutral"
    :icon-left="faBookmark"
    aria-label="Favoritter"
    :aria-pressed="pressed"
    :class="[SHOW_AT[breakpoint], { 'bg-blurple-100 text-primary': pressed }]"
    @click="pressed = !pressed"
  >
    Favoritter
  </Chip>
</template>